<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
  import { viewsXpages, registerXpage } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
  import { fade, fly } from 'svelte/transition';
  import Input from './componentes/Forms/Input.svelte';
  import Modal from './components/Modal.svelte';

  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi,login,miPermiso,iduser } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
	import DatagridTitle from './componentes/DatagridTitle.svelte';
	import DatagridCell from './componentes/DatagridCell.svelte';
	import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
	import Pagination from './components/Pagination.svelte';
	import Searchsection from "./components/Searchsection.svelte";
	import { object2array, postData, verifyAccess } from './scripts';

  //verifyAccess($login,$miPermiso,'usuarios','access')

  /* PERMISOS */
  let viewPage=false;

  if($login===false)
  {
      push('/login')
  } else if( $miPermiso.sucursales.access===false ) {
      push('/sinpermiso')
  } else {
      viewPage=true;
  }
  /* FIN PERMISOS */


  let avanzado=false;
  let uid=null; // CAMBIO AGREGAR VARIABLE
  const res=null;
  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='id';
  let orderDir='ASC';
  let roles= {'0': 'Personalizado' }
  let roles_combo= [{'ALL':'Todos'},{'0': 'Personalizado' }]
  let rol='ALL';
  
  function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
      cargando=true;

      let datos={ 
          'cmd': "sucursales_list",
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir,
      }

      if(avanzado===true)
      {
          if(searchText!='') datos={...datos, 'search':searchText }
      }      

        const res = await postData($urlapi, [datos])
        .then(data => {
            datagrid= object2array(data[0].result);
            dataPagination=data[0].pagination;
            cargando=false;
        });
      
  }

    let edit= function(id) { push('/sucursales/'+id); }

	function orderTable(event) {
    if(cargando===false) {
      pageActual=0;
      orderField=event.detail.order;
      orderDir=event.detail.dir;
      loadData()
    }    
	}


  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer>

      <Titlesection>
        <span slot="title"><i class="bi bi-shop me-1" />Sucursales</span>
        <span slot="toolbar">

          {#if $miPermiso.sucursales.edit===true}
            <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-pencil-square"></i></button></span>
          {/if}
          
          {#if avanzado===false}
            <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {:else}
            <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {/if}

          <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>
         
          <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
        </span>
      </Titlesection>

      {#if avanzado===true}
      <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
          <div class="row">
  
              <div class='col-12 mb-2 mt-2'>
                  <Input label='Filtrar por NOMBRE, COMERCIO, ESTABLECIMIENTO' bind:value={searchText} on:change={eventText} />
              </div>
          </div>
      </div>
      {/if}

      <!-- DATA GRID -->
      <div class="container-fluid mt-2">
        <div class="row">
          <div class="col-12">

              <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable}>

                  <svelte:fragment slot="header">
                        <DatagridTitle width='100px' order="id" title='ID'/>
                        <DatagridTitle order="nombre" title='Sucursal'/>
                        <DatagridTitle order="comercio" title='Comercio'/>
                        <DatagridTitle order="establecimiento" title='Establecimiento'/>
                        <DatagridTitle title='Activo'/>
                  </svelte:fragment>
                  <svelte:fragment slot="body">
                    {#each datagrid as item}
                    <DatagridRow id={item.id} bind:seleccionado={seleccionado} on:select={selected}>
                          <DatagridCell title='ID'>{item.id}</DatagridCell>
                          <DatagridCell title='Nombre' primary>{item.nombre}</DatagridCell>
                          <DatagridCell title='Comercio' primary>{item.comercio}</DatagridCell>
                          <DatagridCell title='Establecimiento' primary>{item.establecimiento}</DatagridCell>
                          <DatagridCell title='Activo'>
                              {#if item.activo==='1'}
                                    <span class='text-success'><i class="bi bi-check-circle me-1"></i> Activo</span>
                              {:else}
                                    <span class='text-danger'><i class="bi bi-x-circle  me-1"></i>No activo</span>
                              {/if}
                          </DatagridCell>
                    </DatagridRow>
                    {/each}
                  
                  </svelte:fragment>
              </Datagrid>

          </div>
        </div>
      </div>

      <!-- PAGINACIÓN -->
      <div class="container mt-3">
        <div class="row">
          <div class="col-12 col-md-6 text-end text-md-start">
            <Infopagination data={dataPagination}/>
          </div>
          <div class="col-12 col-md-6">
            <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
          </div>
        </div>
      </div>

      <Helper bind:text={helper}></Helper>

</AnimationContainer>

{/if}